var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apexchart',{ref:"barChart",staticClass:"apex-charts",attrs:{"dir":"ltr","height":"250","series":_vm.chartData.series,"options":_vm.chartData.chartoptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }